import React, { useEffect, useState } from 'react';
import { Smartphone } from 'lucide-react';
import { motion } from 'framer-motion';

import { getAllPhoneNumber } from '../utils/api/phoneNumberAPI';
import { convertToIndianTimeZone } from '../utils/utils';
import AddPhoneNumberModal from './child/AddPhoneNumberModal';

function PhoneNumberLayer() {
  const [phoneNumberList, setPhoneNumberList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [addPhoneNumberModal, setAddPhoneNumberModal] = useState(false);

  useEffect(() => {
    setLoading(true);
    getAllPhoneNumber()
      .then((data) => setPhoneNumberList(data.phoneNumbers || []))
      .catch((error) => console.error('Error fetching phone numbers:', error))
      .finally(() => setLoading(false));
  }, []);

  const renderEmptyState = () => (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="card h-100 p-0 radius-12 p-10"
    >
      <div
        style={{
          height: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
        }}
      >
        <Smartphone size={100} color="#6b7280" strokeWidth={1.5} />
        <h1 className="text-sm pt-10 pb-10" style={{ color: '#9ca3af' }}>
          Manage Your Numbers with CallHQ
        </h1>
        <p className="text-m" style={{ color: '#9ca3af' }}>
          Seamlessly connect AI agents to real phone numbers for outbound and inbound calls.
        </p>
        <p className="text-m" style={{ color: '#9ca3af' }}>
          Link numbers from Twilio, Vonage, or create free virtual numbers directly via CallHQ.
        </p>
        <div className="d-flex mt-4" style={{ gap: '12px' }}>
          <button type="button" className="btn btn-primary-600 radius-8 px-20 py-11">
            Get a Number
          </button>
          <button type="button" className="btn btn-outline-primary-600 radius-8 px-20 py-11">
            How It Works
          </button>
        </div>
      </div>
    </motion.div>
  );

  if (loading || phoneNumberList.length === 0) {
    return renderEmptyState();
  }

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="card h-100 p-0 radius-12"
    >
      {/* Header */}
      <div className="card-header border-bottom bg-base py-10 px-24 flex align-center" style={{
        justifyContent: 'flex-end'
      }}>

        <button onClick={() =>  setAddPhoneNumberModal(true)} type="button" className="btn btn-primary-600 radius-8 px-16 py-8 d-flex align-center" style={{ fontSize: '14px', fontWeight: 500, gap: '6px' }}>
          + Add a Number
        </button>
      </div>

      {/* Table */}
      <div className="card-body p-24">
        <div className="table-responsive scroll-sm">
          <table className="table bordered-table sm-table mb-0">
            <thead>
              <tr>
                <th className="text-center">ID</th>
                <th className="text-center">Number</th>
                <th className="text-center">Provider</th>
                <th className="text-center">Organization Name</th>
                <th className="text-center">Created At</th>
                <th className="text-center">Status</th>
              </tr>
            </thead>
            <tbody>
              {phoneNumberList.map((phone) => (
                <tr key={phone.id}>
                  <td className="text-center" hover={phone.id} style={{ maxWidth: '180px', wordBreak: 'break-word' }}>
                    {phone.id.length > 10 ? phone.id.slice(0, 15) + "..." : phone.id || '-'}
                  </td>
                  <td className="text-center">{phone?.did?.slice(2) || '-'}</td>
                  <td className="text-center">{phone?.provider || '-'}</td>
                  <td className="text-center">{phone?.organization?.name || '-'}</td>
                  <td className="text-center">
                    {convertToIndianTimeZone(phone?.createdAt) || '-'}
                  </td>
                  <td className="text-center">
                    <span
                      className={`badge ${phone?.status ? 'bg-success' : 'bg-secondary'}`}
                      style={{
                        padding: '4px 10px',
                        fontSize: '12px',
                        borderRadius: '6px',
                      }}
                    >
                      {phone?.status ? 'Active' : 'Inactive'}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
     {addPhoneNumberModal && <AddPhoneNumberModal onClose={() => setAddPhoneNumberModal(false)}/>}
    </motion.div>
  );
}

export default PhoneNumberLayer;
